import T, { t } from '../../../../../../common/components/T';
import css from './SelectProductsModal.module.scss';

export const thead = {
    data: [
        {
            type: 'active-row',
            name: 'activeRow'
        },
        {
            type: 'text',
            name: 'name',
            title: <T textName='name' defaultStr='Название' />,
            align: 'left'
        },
        {
            type: 'text',
            name: 'price_formatted',
            title: <T textName='price' defaultStr='Цена' />,
            sort: 'price'
        },
        {
            type: 'counter',
            name: 'quantity',
            title: <T textName='qty' defaultStr='Кол-во' />
        }
    ]
};

export const transformData = (translation, selectedType) => (data) => {
    const [sets, products] = data?.data?.reduce(
        (acc, item) => {
            if (item.type === 'set') {
                acc[0].push(item);
            }
            if (item.type === 'product') {
                acc[1].push(item);
            }
            return acc;
        },
        [[], []]
    );
    const isSet = selectedType === 0;
    return {
        data: (isSet ? sets : products).map((item) => ({
            activeRow: false,
            name: isSet ? (
                <div className={css.setName}>
                    <p>{item.name}</p>
                    {item?.set_products?.map((prod) => (
                        <p key={prod.id}>{`${prod.name} - ${prod.count} ${t('pc', 'шт', 'all', translation)}`}</p>
                    ))}
                </div>
            ) : (
                item.name
            ),
            price_formatted: item?.price?.price_for_client_formatted || '-',
            quantity: 1,
            id: item?.id,
            fullData: item
        }))
    };
};
